import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./cardSlider.css";
import "../../components/HospitalBacend/hb.css"
import { useState } from "react";

const CardSlider = ({ heading, heading2, data, className = "", slidesToShow = 4 }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const settings = {
    dots: false,
    beforeChange: (current, next) => setActiveIndex(next),

    infinite: true,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: true, 
    autoplaySpeed: 3000,

    responsive: [
      { breakpoint: 1054, settings: { slidesToShow: Math.min(slidesToShow, 3) } },
      { breakpoint: 768, settings: { slidesToShow: Math.min(slidesToShow, 2) } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };
  return (
    <div className={`card-slider ${className}`}>
      <h2 className={heading2 ? "with-h3" : "no-h3"}>{heading}</h2>
      {heading2 && <h3>{heading2}</h3>}

      <Slider {...settings}>
        {Object.entries(data).map(([key, item]) => (
          <div key={key} className="card-slider-card">
            <img src={item.img} alt={item.title} />
            <div className="card-slider-info">
              <h3>{item.title}</h3>
            </div>
          </div>
        ))}
      </Slider>
 
      <div className="custom-dots">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className={`dot ${activeIndex % 3 === i ? "active" : ""}`}
          />
        ))}
      </div>
    </div>
  );

};

export default CardSlider;
